import React from 'react';
import axios from 'axios';
import Logo from './Logo';
import Hagar from './Hagar';
import Rating from './Rating';
import Instructor from './Instructor';
import { translations } from '../translations'

export default class Modal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      member: this.props.selectedResource,
      member_details: null,
      isLoading: true,
      lang: window?.memberSearchConfig?.lang || 'en',
    };

    this.strings = translations[this.state.lang];
    this.close = this.close.bind(this);
  }

  fetchMember(params = {}) {
    let endpoint = window?.memberSearchConfig?.endpoint || 'http://localhost:3000';
    let url = `${endpoint}/api/v1/members/${this.props.selectedResource.member_number}`;

    axios.get(url, {
      ID: params.query
    })
    .then(res => {
      this.setState({
        member_details: res.data[0],
        isLoading: false
      });
    })
    .catch(error => this.setState({ error, isLoading: false }));
  }

  componentDidMount() {
    this.fetchMember();
  }

  close = (e, member) => {
    e.preventDefault();
    this.props.close();
  };

  LoadingIndicator({ isLoading }) {
    return (
      <div>
        { isLoading ? <p>{this.strings.loading}...</p> : null }
      </div>
    );
  }

  firstAid(member){
    return member.first_aid ?
    <div className="membership-card__detail">
      <div className="membership-card__label membership-card__label--inline">{this.strings.first_aid}</div>
      { member?.expiry_dates?.first_aid || member.first_aid }
    </div> : ''
  }

  formatDate(date) {
    console.log(date);
    let d = new Date(date)
    let options = { year: 'numeric', month: 'long', day: 'numeric' };

    return d.toLocaleDateString('en-US', options);
  }

  hasHagarOrFirstAid = (member) => {
     return (
        <>
            {member.hagar && <Hagar />}
            {this.firstAid(member)}
        </>
     )
  }


  content() {
    return (
      <div>
        <div className="membership-card">
        <div className="membership-card_front">
          <div className="membership-card__header">
            <Logo />
            <div className="membership-card-content">
              <div className="member-name">
                {this.state.member.full_name}
                <span className="member-number">#{this.state.member_details.member_number}</span>
              </div>
              <div className={ this.state.member_details.valid_member ? "member-expiry-date" : "member-expiry-date expired" }>
                {this.state.member_details.valid_member ? `${this.formatDate(this.state.member_details.expiry_dates.membership)}` : `Expired on ${this.formatDate(this.state.member_details.expiry_dates.membership)}`}
              </div>
            </div>
          </div>
          <div className="membership-card__body">
            <Instructor wing_type='pg' member={this.state.member_details} />
            <Instructor wing_type='hg' member={this.state.member_details} />
            <Rating wing_type='pg' member={this.state.member_details} include_label />
            <Rating wing_type='hg' member={this.state.member_details} include_label />
            {this.hasHagarOrFirstAid(this.state.member_details)}
          </div>
        </div>
      </div>
    </div>
    );
  }

  render() {
    return (
    <div className="modal">
      <div className="modal-backdrop" onClick={ (e) => this.close(e) } />
      <div className="modal-content">
        {this.state.isLoading? this.LoadingIndicator(this.state.isLoading) : this.content() }
        <button className="modal-close icon " onClick={ (e) => this.close(e) }>
          <svg id="icon-close" viewBox="0 0 7.79 7.79">
            <path d="M7.71,7.11a.28.28,0,0,1,.08.2.3.3,0,0,1-.08.2l-.2.2a.3.3,0,0,1-.2.08.28.28,0,0,1-.2-.08L3.89,4.49.68,7.71a.3.3,0,0,1-.2.08.3.3,0,0,1-.2-.08l-.2-.2A.3.3,0,0,1,0,7.31a.28.28,0,0,1,.08-.2L3.3,3.89.08.68A.3.3,0,0,1,0,.48.3.3,0,0,1,.08.28l.2-.2A.3.3,0,0,1,.48,0a.3.3,0,0,1,.2.08L3.89,3.3,7.11.08A.28.28,0,0,1,7.31,0a.3.3,0,0,1,.2.08l.2.2a.3.3,0,0,1,.08.2.3.3,0,0,1-.08.2L4.49,3.89Z"/>
          </svg>
        </button>
      </div>
    </div>
    )
  }
}


